/** Spanish Pythagorean theorem prompts (ADR 0109 §4). The key uses "no ..." where English writes "not ...". */
const CM = ` cm`;

export const pythagoreanPrompts = {
    hypotenuse: () => `Halla la hipotenusa.`,
    missingSide: () => `Halla el lado que falta.`,
    rightTriangle: (a: number, b: number, c: number) =>
        `¿Se puede formar un triángulo rectángulo con lados de ${a}${CM}, ${b}${CM} y ${c}${CM}?`,
    yes: (aSquared: number, bSquared: number, cSquared: number) =>
        `Sí: ${aSquared} + ${bSquared} = ${cSquared}`,
    no: (aSquared: number, bSquared: number, sum: number, cSquared: number) =>
        `No: ${aSquared} + ${bSquared} = ${sum}, no ${cSquared}`,
};
